import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export function Seo({ title, description, image, noindex = false, jsonLd = null }) {
  const location = useLocation();
  const canonicalUrl = typeof window !== "undefined" ? `${window.location.origin}${location.pathname}` : "";

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
